import React from "react";
import {Alert, Table, Toast, Toaster, Tooltip} from "../../components/ReusableComponents/HtmlComponents/HtmlComponents";
import {useTranslation} from "react-i18next";
import * as PropTypes from "prop-types";
import {CToaster} from "@coreui/react";
import { t } from "../CommonHelper";

export const TableBuilder = (props) => {

    const [t] = useTranslation()

    const columns = props?.columns?.map((item) => {
        // console.log(item, props.sorter && props.sorter[item])
        let def = {}
        if (typeof item === 'string') {
            def['key'] = item;
            def['label'] = t(`lbl.${item}`);
            def['sorter'] = props.sorter && Boolean(props.sorter[item]);
        } else {
            def = item;
        }
        return def;
    })

    const data = Array.isArray(props.data) ? props.data : []

    return (

        <Table
            columns={columns}
            data={data}
            striped={props.striped}
            bordered={props.bordered}
            dark={props.dark}
            hover={props.hover}
            size={props.size}
            pagination={props.pagination}
            scopedSlots={props.scopedSlots}
            loading={props.loading}
            clickableRows={true}
            onRowClick={props.onRowClick}
            columnFilter={props.columnFilter}
            sorter={props.sorter}
            onSorterValueChange={props.onSorterValueChange}
            addTableClasses={props.addTableClasses}
        />
    )
}

export const TopMessage = (props) => {
    // console.log(props)
    let title  = props.status && props.status < 300 ? t("lbl.notification") : t("lbl.alert");
    let className = props.className || "";
    if(props.isServerError){
        title =  t("lbl.error") + ": " + props.errCode;
        className = "server-error";
    }

    return <CToaster position={'top-center'}>
        {Toast({title: title, children: props.message, closeButton: true, autoHide: props.autohide, className: className})}
    </CToaster>
}

TopMessage.prototype = {
    message: PropTypes.any,
    status: PropTypes.number,
}

export const TooltipBuilder = (props) => {

    return Tooltip(props)
}